import React from "react";

const HeatMd = () => (
  <svg width="32" height="33" viewBox="0 0 32 33" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#F05146" fill="none" fillRule="evenodd" strokeLinecap="round">
      <path d="M23.105 16.153c0 4.238-3.332 7.674-7.441 7.674-4.11 0-7.442-3.436-7.442-7.674s3.332-7.675 7.442-7.675c4.109 0 7.441 3.437 7.441 7.675z" strokeWidth="1.444" />
      <path strokeWidth="1.76" d="M15.663 31.504v-4.062M15.663 4.865V.805M23.104 29.53l-2.003-3.576M10.152 6.397l-1.93-3.448M25.106 21.861h.003l3.445 2.053M6.147 10.574l-3.373-2.01M30.548 16.24h-3.94M4.72 16.239H.78M28.554 8.565l-3.374 2.008M2.774 23.914l3.445-2.053h.002M23.104 2.949l-1.93 3.448M10.226 25.954 8.222 29.53" />
    </g>
  </svg>


);

export default HeatMd;
